<template>
  <v-container fluid mt-5>
    <v-layout wrap align-center justify-center>
      <img src="../../../static/LogoVitalab.png" width="300" class />

      <v-flex xs12 md6 md4 mt-4>
        <v-card class="elevation-1">
          <v-card-text>
            <v-form>
              <v-text-field
                prepend-icon="person"
                name="username"
                v-model="user.username"
                label="Usuário"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="password"
                prepend-icon="lock"
                name="password"
                label="Senha"
                type="password"
                @keyup.enter="logar()"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.prevent="logar" :loading="progress" dark color="primary">Baixar</v-btn>
          </v-card-actions>
        </v-card>
        <p>
          Entre com Usuário e Senha fornecidos na sua guia de atendimento para baixar os resultados
          <v-icon @click.prevent="showAjuda()" color="secondary">help</v-icon>
        </p>
        <template v-if="mouseHover">
          <v-col cols="12" md="4">
            <v-hover v-slot:default="{ hover }">
              <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }">
                <v-img src="../../../static/resultados.png" contain></v-img>
              </v-card>
            </v-hover>
          </v-col>
        </template>
        <v-alert :value="alert" color="error">{{msg}}</v-alert>
        
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { downloadFile } from "../../services/appservice";
import { removeToken } from "../../utils/auth";

var sha1 = require("js-sha1");

export default {
  mounted() {
    this.id = this.$route.params.id;
  },
  data: () => ({
    id: "",
    drawer: null,
    user: {},
    password: "",
    logado: {},
    progress: false,
    alert: false,
    msg: "",
    mouseHover: false
  }),
  props: {
    source: String
  },
  methods: {
    logar() {
      if (this.user.username != undefined && this.password != "") {
        this.alert = false;
        this.user.password = this.password;
        this.user.id = this.$route.params.id;
        this.progress = true;
        this.$store
          .dispatch("LoginByUsername", this.user)
          .then(r => {
            this.progress = false;
            switch (r.status) {
              case 200:
                this.carregarPerfil(r.data.user.id);
                break;
              default:
                this.alert = true;
                this.msg = r.data.msg;
                break;
            }
          })
          .catch(error => {
            this.progress = false;
            this.alert = true;
            this.msg = error;
          });
      }
    },
    carregarPerfil(idOS) {
      this.$store.dispatch("LoadMenus").then(r => {
        this.$router.push("/obrigado");

        downloadFile(idOS)
          .then(r => {
            const downloadUrl = window.URL.createObjectURL(new Blob([r.data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            let extencao = r.data.type.split("/");

            link.setAttribute("download", idOS + "." + extencao[1]); //any other extension

            document.body.appendChild(link);
            link.click();
            link.remove();
          })
          .finally(() => {
            removeToken();
          });
      });
    },
    showAjuda() {
      this.mouseHover = this.mouseHover === false ? true : false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/autenticate/login.vue